import LegalPageLayout from "@/components/LegalPageLayout";
import { useLanguage } from "@/hooks/useLanguage";
import { Download } from "lucide-react";

const PDF_URL = "/documents/QBD_Terms_and_Conditions_20250619-ENG.pdf";
const ES_PDF_URL = "https://7030766.fs1.hubspotusercontent-na1.net/hubfs/7030766/Website%202025%20-%20Terms%20and%20Conditions/QBD%20Terms%20and%20Conditions_20250619-ES.pdf";

const DownloadButton = ({ href, label }: { href: string; label: string }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="
      not-prose
      inline-flex w-full sm:w-auto items-center justify-center gap-2
      px-5 py-2.5 min-h-[44px]
      rounded-full
      border border-qbd-blue text-qbd-blue
      font-semibold text-sm
      hover:bg-qbd-blue/5 transition-colors
      focus:outline-none focus:ring-2 focus:ring-qbd-blue/30
      mt-5
    "
  >
    <Download className="h-4 w-4" />
    {label}
  </a>
);

const EffectiveDate = ({ children }: { children: React.ReactNode }) => (
  <div className="not-prose border-l-4 border-qbd-blue bg-qbd-blue/5 pl-4 py-3 pr-4 rounded-r-lg mb-10">
    <p className="text-base font-semibold text-foreground">{children}</p>
  </div>
);

const TermsAndConditions = () => {
  const lang = useLanguage();

  if (lang === "es") {
    return (
      <LegalPageLayout
        title="Términos y Condiciones"
        description="Términos y condiciones que regulan el uso del sitio web y los servicios de QbD Group."
        path="/es/terminos-y-condiciones"
      >
        <EffectiveDate>Fecha de entrada en vigor: 25 de junio de 2025</EffectiveDate>

        <h2 className="!font-bold !mb-3">EN – Terms and Conditions</h2>
        <p>Welcome to our Terms and Conditions page. Here you will find an overview of the legal terms that apply to the services and collaboration with QbD Group.</p>
        <DownloadButton href={PDF_URL} label="Download PDF" />
        <hr className="border-border/60 my-8" />

        <h2 className="!font-bold !mb-3">NL – Algemene Voorwaarden</h2>
        <p>Welkom op onze pagina met Algemene Voorwaarden. Hier vindt u een overzicht van de juridische voorwaarden die van toepassing zijn op de diensten en samenwerking met QbD Group.</p>
        <DownloadButton href={PDF_URL} label="PDF downloaden" />
        <hr className="border-border/60 my-8" />

        <h2 className="!font-bold !mb-3">FR – Conditions Générales</h2>
        <p>Bienvenue sur notre page des Conditions Générales. Vous trouverez ici un aperçu des conditions juridiques applicables à nos services et à la collaboration avec QbD Group.</p>
        <DownloadButton href={PDF_URL} label="Télécharger le PDF" />
        <hr className="border-border/60 my-8" />

        <h2 className="!font-bold !mb-3">PL – Warunki Ogólne</h2>
        <p>Witamy na naszej stronie z Warunkami Ogólnymi. Tutaj znajdziesz przegląd warunków prawnych mających zastosowanie do usług i współpracy z QbD Group.</p>
        <DownloadButton href={PDF_URL} label="Pobierz PDF" />
        <hr className="border-border/60 my-8" />

        <h2 className="!font-bold !mb-3">ES – Términos y Condiciones</h2>
        <p>Te damos la bienvenida a nuestra página de Términos y Condiciones. Aquí encontrarás una descripción general de las condiciones legales que se aplican a los servicios y colaboraciones con QbD Group.</p>
        <DownloadButton href={ES_PDF_URL} label="Descargar PDF" />
      </LegalPageLayout>
    );
  }

  return (
    <LegalPageLayout
      title="Terms & Conditions"
      description="Terms and conditions governing the use of QbD Group's website and services."
      path="/en/terms-and-conditions"
    >
      <EffectiveDate>Effective date: 25 June 2025</EffectiveDate>

      <h2 className="!font-bold !mb-3">EN – Terms and Conditions</h2>
      <p>Welcome to our Terms and Conditions page. Here you will find an overview of the legal terms that apply to the services and collaboration with QbD Group.</p>
      <DownloadButton href={PDF_URL} label="Download PDF" />
      <hr className="border-border/60 my-8" />

      <h2 className="!font-bold !mb-3">NL – Algemene Voorwaarden</h2>
      <p>Welkom op onze pagina met Algemene Voorwaarden. Hier vindt u een overzicht van de juridische voorwaarden die van toepassing zijn op de diensten en samenwerking met QbD Group.</p>
      <DownloadButton href={PDF_URL} label="PDF downloaden" />
      <hr className="border-border/60 my-8" />

      <h2 className="!font-bold !mb-3">FR – Conditions Générales</h2>
      <p>Bienvenue sur notre page des Conditions Générales. Vous trouverez ici un aperçu des conditions juridiques applicables à nos services et à la collaboration avec QbD Group.</p>
      <DownloadButton href={PDF_URL} label="Télécharger le PDF" />
      <hr className="border-border/60 my-8" />

      <h2 className="!font-bold !mb-3">PL – Warunki Ogólne</h2>
      <p>Witamy na naszej stronie z Warunkami Ogólnymi. Tutaj znajdziesz przegląd warunków prawnych mających zastosowanie do usług i współpracy z QbD Group.</p>
      <DownloadButton href={PDF_URL} label="Pobierz PDF" />
      <hr className="border-border/60 my-8" />

      <h2 className="!font-bold !mb-3">ES – Términos y Condiciones</h2>
      <p>Te damos la bienvenida a nuestra página de Términos y Condiciones. Aquí encontrarás una descripción general de las condiciones legales que se aplican a los servicios y colaboraciones con QbD Group.</p>
      <DownloadButton href={ES_PDF_URL} label="Descargar PDF" />
    </LegalPageLayout>
  );
};

export default TermsAndConditions;
